<template>
    <b-modal
        v-model="modalVisible"
        :title="`Import ${subject}`"
        hide-footer
        size="lg"
    >
        <b-card no-body>
            <b-tabs card>
                <b-tab :title="`Upload ${subject}`" active>
                    <b-card-body
                        :title="`Import ${subject}`"
                        v-show="!importList.length"
                    >
                        <simple-csv-import
                            v-model="importList"
                            :startRowNo="configurationSettings.rowno"
                            :columnsMap="columnsMap"
                        >
                        </simple-csv-import>
                    </b-card-body>

                    <b-card-body v-show="importList.length > 0">
                        <b-container>
                            <b-row>
                                <b-col> {{ `Total ${subject}` }} </b-col>
                                <b-col>
                                    {{ importList.length }}
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col> Status: </b-col>
                                <b-col> Ready to Upload </b-col>
                            </b-row>

                            <b-row>
                                <b-col>
                                    <b-button-group
                                        size="sm"
                                        class="float-right"
                                    >
                                        <b-button
                                            v-show="importList.length > 0"
                                            @click="cancel()"
                                            variant="outline-danger"
                                        >
                                            Cancel
                                        </b-button>
                                        <b-button
                                            v-show="importList.length > 0"
                                            @click="uploadData"
                                            variant="success"
                                            :disabled="submitting"
                                        >
                                            <span v-if="!submitting"
                                                >Upload</span
                                            >
                                            <b-spinner
                                                small
                                                v-if="submitting"
                                            ></b-spinner>
                                            <span v-if="submitting"
                                                >Uploading...</span
                                            >
                                        </b-button>
                                    </b-button-group>
                                </b-col>
                            </b-row>
                            <b-table
                                :items="statusList"
                                responsive
                                :per-page="perPage"
                                :current-page="currentPage"
                                :fields="tableFields"
                            >
                                <template #cell(status)="data">
                                    <b-badge
                                        :id="`upload-badge-${data.index}`"
                                        :variant="
                                            data.value | filterStatusVariant
                                        "
                                        >{{ data.value }}</b-badge
                                    >
                                    <!-- Show tooltip if there are errors -->
                                    <b-tooltip
                                        v-if="data.item.error_list.length > 0"
                                        :target="`upload-badge-${data.index}`"
                                        triggers="hover"
                                    >
                                        Errors:
                                        <!-- loop through the list of errors and display each -->
                                        <ul
                                            v-for="error_set in data.item
                                                .error_list"
                                            :key="error_set.index"
                                        >
                                            <li
                                                v-for="error in error_set[1]"
                                                :key="`error-${error}`"
                                            >
                                                {{ error }}
                                            </li>
                                        </ul>
                                    </b-tooltip>
                                </template>
                            </b-table>
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="statusList.length"
                                :per-page="perPage"
                                aria-controls="my-table"
                            ></b-pagination>
                        </b-container>
                    </b-card-body>
                </b-tab>
                <b-tab title="Settings">
                    <b-card-body>
                        <upload-data-settings
                            @input="updateConfiguration"
                            :value="configurationSettings"
                            :data-fields="fields"
                        ></upload-data-settings>
                    </b-card-body>
                </b-tab>
            </b-tabs>
        </b-card>
    </b-modal>
</template>

<script>
import SimpleCsvImport from '@/components/SimpleCsvImport'
import UploadDataSettings from '@/components/UploadDataSettings'
import { capitalCase } from 'change-case'
import popupMixins from '@/mixins/popupMixins'
import settingsMixins from '@/mixins/settingsMixins'

/**
 * The possible statuses during upload
 */
const statuses = {
    COMPLETE: 'complete',
    ERROR: 'error: hover for details',
    PENDING: 'ready',
    CHECKING: ' checking',
    SAVING: 'saving',
    INVALID_LOCATION: 'complete: invalid location',
    GEOCODING: 'geocoding',
}

export default {
    name: 'ImportForm',
    components: { SimpleCsvImport, UploadDataSettings },
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        subject: {
            type: String,
            required: true,
        },
        fields: {
            type: Array,
            required: true,
        },
        settingsKeyName: {
            type: String,
            required: true,
        },
        uploadRecord: {
            type: Function,
            required: true,
        },
    },
    mixins: [popupMixins, settingsMixins],
    data: () => {
        return {
            perPage: 15,
            currentPage: 1,
            modalVisible: false,
            importList: [],
            files: [],
            file: {},
            status: false,
            model: {},
            submitting: false,
            hasErrors: false,
            statusList: [],
        }
    },

    filters: {
        filterStatusVariant(status) {
            console.log('status', status)
            switch (status) {
                case statuses.INVALID_LOCATION:
                    return 'warning'
                case statuses.ERROR:
                    return 'danger'
                case statuses.COMPLETE:
                    return 'success'
                default:
                    return 'light'
            }
        },
    },

    computed: {
        columnsMap() {
            console.log(
                'this.configurationSettings',
                this.configurationSettings
            )
            const x = { ...this.configurationSettings }
            delete x.rowno
            return x
        },

        tableFields() {
            const _fields = this.fields.map(x => ({
                key: x.name,
                label: x.name.toUpperCase(),
            }))
            _fields.unshift(
                { key: 'no', label: 'No', stickyColumn: true },
                { key: 'status', label: 'Status', stickyColumn: true }
            )
            return _fields
        },
    },
    watch: {
        value: function (val) {
            this.modalVisible = val
        },
        importList: {
            handler: function (val) {
                if (val.length > 0) {
                    this.loadStatusList()
                }
            },
            deep: true,
        },
    },
    mounted() {
        console.log('location', location.href)
        this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
            console.log('Modal is about to be shown', bvEvent, modalId)
        })
        this.$root.$on('bv::modal::hide', () => {
            this.$emit('input', false)
        })

        this.model = this.fields.reduce((obj, field) => {
            obj[field] = field == 'country' ? 'Jamaica' : ''
            return obj
        }, {})
    },

    methods: {
        /**
         * Where the value for the column index is -1, set the column setting to undefined.
         * @param data The data settings
         */
        preprocessDataSettings(data) {
            var dataCopy = { ...data }
            for (const [key, value] of Object.entries(dataCopy)) {
                dataCopy[key] = value == -1 ? undefined : value
            }
            return dataCopy
        },
        /**
         * Validates the form data based on whether the field is required or not
         * @param data The form data
         * @returns A list of errors if there are any or an empty list if there are none
         */
        validateDataSettings(data) {
            var errors = []
            for (const field of this.fields) {
                if (data[field.name] == undefined && field.required) {
                    errors.push(`${capitalCase(field.name)} is required`)
                }
            }
            return errors
        },

        async updateConfiguration(data) {
            try {
                data = this.preprocessDataSettings(data)
                // validate data
                var result = this.validateDataSettings(data)

                // show errors if any
                if (result.length) {
                    for (const err of result) {
                        this.doToast('Error', err, 'danger')
                    }
                    this.doToast('Error', 'Settings Update Failed', 'danger')
                    // abort update due to errors
                    return
                }

                const text_value = JSON.stringify(data)
                const bool_value = false
                const key = this.settingsKey
                const { settingsKeyName, settingsKey } = this
                console.log({ key, text_value, settingsKeyName, settingsKey })
                await this.$store.dispatch('company/updateConfiguration', {
                    key,
                    text_value,
                    bool_value,
                })

                this.doToast(
                    'Success',
                    'Settings updated successfully',
                    'success'
                )
            } catch (err) {
                console.log(err.response.data.error.message)
                this.doToast(
                    'Error',
                    `Settings failed to update. ${err.response.data.error.message}`,
                    'danger'
                )
            }
        },

        onSubmit(data) {
            console.log('data', data)
        },
        processError(err) {
            console.log('err', err)
        },
        loadStatusList() {
            this.statusList = this.importList.map((x, i) => {
                let status = statuses.PENDING
                let no = i + 1
                return { ...{ no, status, error_list: [] }, ...x }
            })
        },
        checkEntry(record) {
            const emailRegex =
                /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/
            //const textRegex = /^[a-zA-Z0-9\s.-]+$/
            const textRegex = /^[ A-Za-z0-9_@./#&+-,'"]*$/ // /^[a-zA-Z0-9-_. ]*$/
            for (const field of this.fields) {
                const value = record[field.name]
                //check if email
                if (field.type == 'email' && value && !emailRegex.test(value)) {
                    console.log('invalid email value', { field, value })
                    return -1
                }
                //must be valid text
                if (field.type == 'text' && value && !textRegex.test(value)) {
                    console.log('invalid text value', { field, value })
                    return 0
                }

                //check if required
                if (field.type == 'text' && field.required && !value) {
                    console.log('Field is Required', { field })
                    return 0
                }
            }
            return 1
        },

        previewFiles() {},
        cancel() {
            this.$emit('cancel')
            this.importList = []
        },

        async uploadData() {
            const $this = this
            const setLoading = state => {
                $this.submitting = state
            }
            for (let i = 0; i < this.importList.length; i++) {
                const check = this.checkEntry(this.importList[i])
                console.log('check', check)
                await this.uploadRecord(
                    this.importList[i],
                    this.statusList[i],
                    check,
                    statuses,
                    setLoading
                )
            }
            //this.$emit('success')
            //this.$emit('cancel')
            //this.importList = []
        },
    },
}
</script>

<style></style>
